/* ─── Product card swipe (mobile) ───────────────────────────────────────── */
(function () {
  if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  function initCard(gallery) {
    const img = gallery.querySelector('[data-swipe-image]');
    if (!img) return;

    // Dans un carousel, le swipe horizontal est géré par le scroll natif — on ne touche pas
    if (gallery.closest('.carousel-track')) return;

    // Force overflow hidden and position second image off-screen right via inline styles
    // (inline styles beat Tailwind class specificity reliably)
    gallery.style.overflow = 'hidden';
    img.style.transition = 'transform 0.35s ease';
    img.style.opacity = '1';
    img.style.transform = 'translateX(100%)';

    // Peek hint: slide image 2 in ~22% once, then back
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !gallery.dataset.peeked) {
            gallery.dataset.peeked = '1';
            setTimeout(() => {
              img.style.transform = 'translateX(78%)';
              setTimeout(() => { img.style.transform = 'translateX(100%)'; }, 500);
            }, 300);
          }
        });
      },
      { threshold: 0.6 }
    );
    observer.observe(gallery);

    // Le tile-link (absolute inset-0 z-10) intercepte les touch events sur mobile.
    // On écoute au niveau du li.tile-product parent pour capter les événements qui remontent.
    const tileEl = gallery.closest('.tile-product') || gallery;
    tileEl.style.touchAction = 'pan-y';

    let startX = 0;
    tileEl.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    tileEl.addEventListener('touchend', (e) => {
      const delta = startX - e.changedTouches[0].clientX;
      if (delta > 40) {
        img.style.transform = 'translateX(0)';
      } else if (delta < -40) {
        img.style.transform = 'translateX(100%)';
      }
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-swipe-gallery]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* ─────────────────────────────────────────────────────────────────────────── */

window['ThemeTile'] = (link, title) => {
  return {
    hover: false,
    link: link,
    title: title,
    showLabel() {
      this.labelContent = this.$refs.labelContent.innerHTML;
      this.focusVisible = this.$refs.tileLink.matches(':focus-visible');
    },
    hideLabel() {
      this.labelContent = '';
      this.focusVisible = false;
    },
    async openQuickView() {
      this.$store.quickview.render(link);
      this.$store.modals.open('productQuickView');
    },
  };
};
